import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'aph-custom-load-file',
  templateUrl: './aph-custom-load-file.component.html',
  styleUrls: ['./aph-custom-load-file.component.scss']
})
export class AphCustomLoadFileComponent implements OnInit {

  // Configuraciones de visualización
  @Input() title: string = 'Seleccione Archivo';
  @Input() acceptFormats: string = '.xls,.xlsx,.csv';
  @Input() iconClass: string = 'fa-file-excel-o';
  
  // Configuración del botón para mostrar/ocultar el HTML
  @Input() enableToggleButton: boolean = false;
    
  // Configuración del botón de Enviar
  @Input() enableSubmitButton: boolean = true;
  @Input() submitButtonText: string = 'Enviar';

  // Estados externos (cargas, bloqueos)
  @Input() saving: boolean = false;
  @Input() working: boolean = false;

  // Eventos que emitirá el componente
  @Output() onSubmitClick = new EventEmitter<File[]>();
  @Output() onFilesChanged = new EventEmitter<File[]>(); // Opcional, por si necesitas validar algo al instante

  @ViewChild('fileInput', { static: false }) fileInput!: ElementRef;

  // Estados internos
  uploadedFiles: File[] = [];
  fileButtonClass: string = 'btn-outline-warning';
  constructor() { }

  ngOnInit(): void {
  }

  onFileSelect(files: FileList | null): void {
    if (!files) return;
    
    // Aquí puedes agregar tu lógica de validación de extensión si lo deseas
    for (let i = 0; i < files.length; i++) {
      this.uploadedFiles.push(files[i]);
    }
    
    this.updateButtonClass();
    this.onFilesChanged.emit(this.uploadedFiles);
  }

  deleteFile(file: File): void {
    this.uploadedFiles = this.uploadedFiles.filter(x => x !== file);
    if (this.fileInput) {
      this.fileInput.nativeElement.value = ''; // Limpiar el input oculto
    }
    this.updateButtonClass();
    this.onFilesChanged.emit(this.uploadedFiles);
  }

  updateButtonClass(): void {
    this.fileButtonClass = this.uploadedFiles.length > 0 ? 'btn-outline-success' : 'btn-outline-warning';
  }

  onSendClick(): void {
    // Emitimos los archivos al componente padre (PlanBComponent)
    this.onSubmitClick.emit(this.uploadedFiles);
  }

  // Método público para limpiar el componente desde el padre tras guardar exitosamente
  public clearFiles(): void {
    this.uploadedFiles = [];
    if (this.fileInput) {
      this.fileInput.nativeElement.value = '';
    }
    this.updateButtonClass();
  }
}
